import { ProgressIndicator } from '@fluentui/react';
import { doc, onSnapshot } from 'firebase/firestore';

import RenderDialog from '../../../../addons/RenderDialog';
import { firestore } from '../../../../App/firebase';
import { getAsync } from '../../../../utils/api';

export default async (formId: string) => {
  const encodedFormId = encodeURIComponent(formId);
  const { data: formData, versionId } = await getAsync(
    `/forms/get?id=${encodedFormId}`
  );

  if (!formData.PDFDocumentId) {
    let closeModal: () => void;

    const removeListener = onSnapshot(
      doc(firestore, "forms_v2", formId, "versions", versionId),
      (snapshot) => {
        console.log(snapshot.data());
        if (snapshot.data()!.PDFDocumentId) {
          removeListener();
          showPDF(encodedFormId).then(closeModal);
        }
      }
    );

    closeModal = RenderDialog({
      title: "PDF Oluşması Bekleniyor",
      subText:
        "Bu işlem birkaç dakika sürebilir. Sayfayı kapatmak bu işlemi etkilemez.",
      showCloseButton: true,
      onClosed: removeListener,
      children: <ProgressIndicator />,
    });
  } else {
    await showPDF(encodedFormId);
  }
};

const showPDF = async (encodedFormId: string) => {
  const pdf = await getAsync("/forms/get-pdf?id=" + encodedFormId);
  const url = URL.createObjectURL(pdf);

  window.open(url);
};
